import _ from 'lodash';

const _scopedState = state => state.entities.smartUrl;

const _smartUrlsById = state => _scopedState(state).byId;
const smartUrls = state => _.values(_smartUrlsById(state));

export default {
  smartUrls,
};
